import React from 'react';
import { renderRoutes } from 'router/renderRoutes';

/**
 * @todo make component wrappers with layout and contexts
 */
class Module {
  constructor(module) {
    this.routes = module.routes;
    this.layout = module.layout;
    this.contexts = module.contexts || [];
  }

  renderRoutes() {
    return renderRoutes(this.routes);
  }

  render() {
    if (this.layout) {
      return this.renderWithLayout();
    } else {
      return this.renderWithoutLayout();
    }
  }

  renderWithLayout() {
    return <this.layout>{this.renderRoutes()}</this.layout>;
  }

  renderWithoutLayout() {
    return <>{this.renderRoutes()}</>;
  }
}

export default Module;
